export default __webpack_public_path__ + "static/media/IconoBillete.fb65d1d6.svg";